import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getHdfcMfInsights } from "../actions";
import { getRouting, formDataGenerator } from '../../../../../utils/common';
import { Link } from "react-router-dom";
import "./style.scss";
import PaginationComponent from "../../../general/PaginationComponent";
import SubscribeKnowledgeStack from "../SubscribeKnowledgeStack";
import { Helmet } from "react-helmet";


const MfInsights = (props) => {
  const {
    getHdfcMfInsights,
    getInsightsData,
    location: { pathname },
  } = props;

  const [limit, setLimit] = useState(16);
  const [offset, setOffset] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchFilter, setsearchFilter] = useState("");
  const [data, setData] = useState([]);
  const [metaData, setMetaData] = useState("");

  const getPaginatedData = (page) => {
    loadData(page);
  };

  const handleInputSearchName = (e) => {
    setsearchFilter(e.target.value);
    setActivePage(1);
  };

  const loadData = (page) => {
    const offsetValue = limit * (page - 1);
    let params = {
      search: searchFilter ? searchFilter : "",
      limit: limit,
      offset: limit * (page - 1),
    };
    getHdfcMfInsights(formDataGenerator(params), "hdfcMfInsight");
    let unit = window.innerHeight / 100;
    window.scrollTo({ top: 40 * unit });
  };

  useEffect(() => {
    let params = {
      search: searchFilter ? searchFilter : "",
      limit: limit,
      offset: offset,
      // tags: "",
    };
    getHdfcMfInsights(formDataGenerator(params), "hdfcMfInsight");
  }, [searchFilter]);

  useEffect(() => {
    if (getInsightsData && getInsightsData.items) {
      setTotalRecords(getInsightsData.count ? getInsightsData.count : 0);
    }
    if (getInsightsData && getInsightsData.meta) {
      setMetaData(getInsightsData.meta);
    }
  }, [getInsightsData]);

  const handleInputSearchNameTag = (e) => {
    setsearchFilter(e);
  };

  return (
    <div className="wrapper">
      {metaData && metaData !== null && (
        <Helmet>
          <title>{metaData.title ? metaData.title : ""}</title>
          <meta
            name="description"
            content={metaData.description ? metaData.description : ""}
          />
          <meta
            name="keywords"
            content={metaData.keywords ? metaData.keywords : ""}
          />
          <meta
            property="og:title"
            content={metaData.og_title ? metaData.og_title : ""}
          />
          <meta
            property="og:description"
            content={metaData.og_description ? metaData.og_description : ""}
          />
          <meta
            property="og:image"
            content={metaData.og_image ? metaData.og_image : ""}
          />
          <meta
            property="og:url"
            content={metaData.og_url ? metaData.og_url : ""}
          />
        </Helmet>
      )}
      <section className="aboutHead">
        <div className="container">
          <div className="d-flex dropdowncls">
            <div className="me-auto">
              <div>
                <h1>
                  <span>HDFC MF</span> Insights
                </h1>
              </div>
            </div>
            <nav
              aria-label="breadcrumb"
              className="align-self-center breadCrumbCust d-md-inlin"
            >
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={getRouting(`/`)}>Home</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={getRouting(`/knowledge-stack`)}>
                    Knowledge Stack
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active breadcolor"
                  aria-current="page"
                >
                  HDFC MF Insights
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>

      <section>
        <div className="container mfinsight">
          <p className="my-4">
          Get Insights on the latest and evolving trends that can help with your investment decisions.
          </p>
          <div className="row mt-3">
            <div className={searchFilter ? "col-md-5 d-flex" : "col-md-4 d-flex"}>
              <div className="input-group mb-3 ipgroup">
                <span
                  className="input-group-text serchcolor"
                  id="inputGroup-sizing-default"
                >
                  <img src="/images/New/grey-search.svg" alt="search" />
                </span>
                <input
                  type="text"
                  className="form-control searchb ps-0 py-2"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-default"
                  placeholder="Search..."
                  onChange={handleInputSearchName}
                  value={searchFilter}
                />
              </div>
              {searchFilter ? (
                <button
                  className="btn resetbtn"
                  onClick={(e) => handleInputSearchNameTag("")}
                >
                  Reset
                </button>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="row mt-4">
            {getInsightsData &&
              getInsightsData.items &&
              getInsightsData.items.length > 0 ?
              (getInsightsData.items.map((data) => (
                <div className="col-md-3 mb-3">
                  <div className='card'>
                    <a href={data.fileData && data.fileData.url} target="_blank">
                      <img
                        src={data.imageURL && data.imageURL.url}
                        className="card-img-top w-100"
                        alt={data.imageURL && data.imageURL.alt}
                      />
                    </a>
                    <div className="card-body px-0">
                      <a href={data.fileData && data.fileData.url} target="_blank">
                        <h5 className="card-title">
                          {data.title}
                        </h5>
                      </a>
                      <p className="card-text">{data.description}</p>
                      <p className='timestamp'>{data.time}</p>
                    </div>
                  </div>
                </div>
              )))
              : (
                <div className='nodata'>
                  <p>no content found</p>
                </div>
              )
            }
          </div>

          {totalRecords > 16 && (
            <div className="row">
              <div className="col-md-12">
                <div className="paginate d-flex justify-content-center">
                  <PaginationComponent
                    totalRecords={totalRecords}
                    activePage={activePage}
                    setActivePage={setActivePage}
                    data={data}
                    limit={limit}
                    getPaginatedData={getPaginatedData}
                    itemsCountPerPage={limit}
                  />
                </div>
              </div>
            </div>
          )}

          <SubscribeKnowledgeStack type="HDFC MF Insighs" article="" />
        </div>
      </section>
    </div>
  );
};
const mapStateToProps = (state) => ({
  getInsightsData: state.KnowledgeStack.mfInsightsData,
});
const mapDispatchToProps = (dispatch) => ({
  getHdfcMfInsights: bindActionCreators(getHdfcMfInsights, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MfInsights);
